import { useEffect, useState } from 'react';

interface UseTimeoutVisabilityOptions {
    timeout?: number;
    onTimeout?: () => void;
    dependencies?: any[];
}

const useTimeoutVisability = (options: UseTimeoutVisabilityOptions = {}) => {
    const { timeout = 5000, onTimeout, dependencies = [] } = options;
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        // Reset visibility when dependencies change
        setIsVisible(true);
        
        const timer = setTimeout(() => {
            setIsVisible(false);
            onTimeout?.();
        }, timeout);

        return () => clearTimeout(timer);
    }, [timeout, onTimeout, ...dependencies]);

    return { isVisible, setIsVisible };
};

export default useTimeoutVisability; 